import { render } from "./contact-button.vue?vue&type=template&id=37e76d2c&scoped=true"
import script from "./contact-button.vue?vue&type=script&lang=js"
export * from "./contact-button.vue?vue&type=script&lang=js"

import "./contact-button.vue?vue&type=style&index=0&id=37e76d2c&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e76d2c"]])

export default __exports__